import { TextInputAppearances, TextInputControlSizes, TextInputTypes, ImplicitSubmissionBlockingTypes as TextInputImplicitSubmissionBlockingTypes } from "../text-input/text-input.options.js";
/**
 * Values for the `control-size` attribute on SearchBox elements.
 *
 * @public
 */
export const SearchBoxControlSizes = {
    ...TextInputControlSizes
};
/**
 * Values for the `appearance` attribute on SearchBox elements.
 *
 * @public
 */
export const SearchBoxAppearances = {
    ...TextInputAppearances
};
/**
 * Values for the `type` attribute on SearchBox elements.
 *
 * @public
 */
export const SearchBoxTypes = {
    ...TextInputTypes
};
/**
 * Input types that block implicit form submission.
 *
 * @public
 */
export const ImplicitSubmissionBlockingTypes = [
    ...TextInputImplicitSubmissionBlockingTypes
];
/**
 * SearchBox event names.
 *
 * @public
 */
export const SearchBoxEventNames = {
    search: "search"
};
//# sourceMappingURL=search-box.options.js.map